import ComponentLayout from '~/src/layouts/component-layout';
import { Link, Text } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { AccessibilityLink } from '~/src/components/accessibility-link';
import { RailsProvider, RailsComponentLink } from '~/src/components/rails-provider';
import * as React from 'react';
export default {
  ComponentLayout,
  Link,
  Text,
  GatsbyLink,
  AccessibilityLink,
  RailsProvider,
  RailsComponentLink,
  React
};